import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
// import { ReactComponent as DNAIcon } from '../assets/icons/dna-icon.svg';
// import { ReactComponent as ExploreArrow } from '../assets/icons/double-arrow.svg';
import SmallBanner from '../components/smallBanner';
import { BASE_URL, GET_BLOG_BY_ID } from "../ApiUrl";
import axios from "axios";

const BlogView = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const uuid = queryParams.get('uuid');

    const [blogdata, setBlogdata] = useState(null);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const result = await axios.get(BASE_URL + GET_BLOG_BY_ID + `?uuid=${uuid}`);
                setBlogdata(result.data.blog);
            } catch (error) {
                console.error("Failed to load blog", error);
            }
        };
        if (uuid) {
            fetchBlog();
        }
    }, [uuid]);

    // console.log(blogdata, "blogdatablogdatablogdata");


    return (
        <main className="blogView-page">
            {blogdata ? (
                <>
                    <SmallBanner Heading={blogdata.title} />
                    <section className="blog-content-wrapper py-100 pb-0">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-xl-7 col-lg-8 col-md-12 col-12">
                                    <img
                                        src={BASE_URL + blogdata.image}
                                        alt="Blog Banner"
                                        className="blog-banner"
                                    />
                                    {/* <div className="blog-desc" dangerouslySetInnerHTML={{ __html: blogdata.content }} /> */}
                                    <div
                                        className="blog-desc"
                                        dangerouslySetInnerHTML={{
                                            __html: blogdata.content.replace(
                                                /<img[^>]+>/g,
                                                (match) => match.replace('<img', '<img style="width: 360px; height: 300px; margin: 5px; class="col-6 d-flex"')
                                            ).replace(
                                                /<a[^>]*>/g,
                                                (match) => match.replace('<a', '<a style="color: #007F35;"')
                                            ),
                                        }}
                                    />

                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <div className="text-center">
                    <p>Loading...</p>
                </div>
            )}

        </main>
    );
};

export default BlogView;


